module.exports = __webpack_public_path__ + "static/img/IMG_20240816_172105.6bc7bffe.jpg";